const ACCESS_RANK = { READ: 1, WRITE: 2 };

function collapseGrants(items) {
  const byCode = new Map();
  items.forEach((item) => {
    const code = item?.resource_code;
    if (!code) return;
    const current = byCode.get(code);
    if (!current) {
      byCode.set(code, item);
      return;
    }
    const nextRank = ACCESS_RANK[item.access_level_code] || 0;
    const currentRank = ACCESS_RANK[current.access_level_code] || 0;
    if (nextRank > currentRank) byCode.set(code, item);
  });
  return Array.from(byCode.values());
}

export function scopeByRoles(items, roleNames) {
  const list = Array.isArray(items) ? items : [];
  const names = (roleNames || []).map((name) => String(name || "").trim()).filter(Boolean);
  if (!names.length) return collapseGrants(list);

  const allowed = new Set(names);
  const tagged = list.some((item) => item?.role_name);
  if (!tagged) return collapseGrants(list);

  return collapseGrants(
    list.filter((item) => item?.role_name && allowed.has(item.role_name)),
  );
}
